import React from 'react';
import DisabledCommentIcon from '@wix/da-ds/pkg/Icons/DisabledComment';
import classnames from 'classnames';
import s from './DisabledComment.scss';
const DisabledComment = ({ className , title  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['comments-disabled'], className)
    }, /*#__PURE__*/ React.createElement(DisabledCommentIcon, null), /*#__PURE__*/ React.createElement("span", {
        className: s['comments-disabled-text']
    }, title));
};
DisabledComment.displayName = 'DisabledComment';
export default DisabledComment;
